// CANONICAL COPY (GH #7115). src/constants/obligations/obl-payment-application-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-payment-application-security',
  title: 'Perform public-facing web application security assessment',
  description:
    'Confirm that public-facing web applications (including payment applications within the cardholder data environment) are protected against known attacks. At least annually, and after any significant change, conduct an application security assessment (manual or automated) OR deploy an automated technical solution that continually detects and prevents web-based attacks (e.g. web application firewall). Custom application code shall be reviewed for common vulnerabilities prior to deployment and after significant change.',
  category: 'technical',
  scfIds: ['SCF-DEV-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Application security assessment report or WAF operating procedure is published',
    },
    { type: 'document-within-sla', description: 'Assessment / procedure review is not overdue' },
    {
      type: 'manual-attestation',
      description: 'Confirm the application security assessment was actually performed',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
